export default "__VITE_ASSET__vAeH5dtX__"